import { section } from '@/neon';
import { add, qs } from '@fluorescent/dom';

import scrollIntoView from '@/lib/scrollIntoView';
import isFirstSectionOnHomepage from '@/lib/homePage';
import { backgroundVideoHandler } from '@/lib/a11y';

const selectors = {
  videoWrapper: '.video-hero__video',
};

section('video-hero', {
  onLoad() {
    this.scrollAnimation = scrollIntoView(this.container);
    const videoWrapper = qs(selectors.videoWrapper, this.container);

    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, 'first-full-height');
    }

    if (videoWrapper) {
      this.videoHandler = backgroundVideoHandler(this.container);
    }
  },

  onUnload() {
    this.scrollAnimation.unload();
    this.videoHandler && this.videoHandler();
  },
});
